import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import RegulationObjectsDataGrid from '@/features/portfolioHierarchy/components/RegulationObjectsDataGrid'
import { PortfolioHierarchyRouteInformation } from '@/features/portfolioHierarchy/constants'
import { usePortfolioHierarchyLayout } from '@/features/portfolioHierarchy/PortfolioHierarchyLayout'

function RegulationObjectsIndex() {
  const { t } = useTranslation()
  const { setPageConfig } = usePortfolioHierarchyLayout()

  useEffect(() => {
    setPageConfig({
      title: t('component.page_header.regulation_objects'),
      breadcrumbs: [
        {
          text: t('component.page_header.portfolio_hierarchy'),
          to: PortfolioHierarchyRouteInformation.INDEX.navigationPath,
        },
      ],
      pageTag: 'regulation_objects',
      activeTab: PortfolioHierarchyRouteInformation.REGULATION_OBJECTS.navigationPath,
    })
  }, [])

  return <RegulationObjectsDataGrid />
}

export default RegulationObjectsIndex
